import { Section } from '../../models';

/**
 * The sections whose References tab is open.
 *
 * A section belongs here once its References rows are authored and its markers'
 * Causes text has somewhere to point; an accidental row elsewhere should not
 * open a tab on its own. Membership is necessary but NOT sufficient — both call
 * sites still check that the fired root-cause categories actually have
 * References rows, which is what keeps the tab hidden for, say, a Nutrients
 * panel where only ferritin is off (homocysteine, 8320/8330, owns the only
 * References rows there) or an Electrolytes panel where only chloride, CO2 or
 * the anion gaps are.
 *
 * Liver / Biliary, Nutrients, Electrolytes and Stress & Adrenal Balance joined
 * through 2026-08 as their research passes landed. Electrolytes (sodium
 * 9000/9010, potassium 9020/9030) and Stress & Adrenal Balance (Na/K ratio
 * 90000/90010) had to ship their rows and their listing together: their Causes
 * text carries inline "(n)" markers, which render as plain unlinked numbers
 * until the References rows exist to resolve them.
 *
 * This list was duplicated by hand in tabs-component.tsx and
 * section-notes-digest.tsx, which meant a section could have its tab open on
 * screen while the Notes digest silently dropped it. One list now, read by
 * both.
 *
 * Thyroid and Digestion are deliberately absent. Both have reference rows
 * authored, but Digestion has no possibleRootCauseCategoriesFor case, so
 * nothing reaches its 85000+ rows anyway; they join when those sections do.
 */
export const SECTIONS_WITH_REFERENCES_TAB: Section[] = [
  Section.GLUCOSE,
  Section.WBC,
  Section.PLATELETS,
  Section.LIVER_BILIARY,
  Section.NUTRIENTS,
  Section.ELECTROLYTES,
  Section.STRESS_ADRENAL,
];

export function sectionHasReferencesTab(section: string): boolean {
  return SECTIONS_WITH_REFERENCES_TAB.some(s => s === section);
}
